import { getStats } from "../api/api";

/**
 * Servicio simplificado para verificar estado de procesamiento de archivos
 */
const AudioProcessingService = {
  // Cache para evitar llamadas repetidas
  _lastSystemStatus: null,
  _lastFetchTime: 0,
  
  /**
   * Obtener estado del sistema
   * @returns {Promise<Object>} Información de estado
   */
  async getSystemStatus() {
    // Evitar múltiples llamadas en un tiempo corto (500ms)
    const now = Date.now();
    if (now - this._lastFetchTime < 500 && this._lastSystemStatus) {
      return this._lastSystemStatus;
    }
    
    try {
      const response = await getStats();
      console.log("Estado del sistema:", response);
      
      // Normalizar respuesta
      const result = {
        processing: Array.isArray(response.processing) ? response.processing : 
                   (response.processing ? [response.processing] : []),
        queueSize: response.queueSize || 0,
        queued: Array.isArray(response.queued) ? response.queued : 
               (response.queued ? [response.queued] : [])
      };
      
      // Guardar en caché
      this._lastSystemStatus = result;
      this._lastFetchTime = now;
      
      return result;
    } catch (error) {
      console.error("Error al obtener estado del sistema:", error);
      return {
        processing: [],
        queued: [],
        queueSize: 0
      };
    }
  },

  /**
   * Convertir estado a formato UI
   * @param {string} status - Estado
   * @returns {string} Estado para UI
   */
  mapStatusToUI(status) {
    if (!status) return 'processing';
    
    status = status.toLowerCase();
    
    if (status.includes('comple') || status.includes('done')) return 'completed';
    if (status.includes('error') || status.includes('fail')) return 'error';
    if (status.includes('cancel')) return 'cancelled';
    if (status.includes('pend') || status.includes('queue')) return 'pending';
    
    return 'processing';
  },

  /**
   * Calcular progreso según estado
   * @param {string} status - Estado 
   * @returns {number} Progreso (0-100)
   */
  calculateProgress(status) {
    if (!status) return 50;
    
    status = status.toLowerCase();
    
    if (status.includes('comple') || status.includes('done')) return 100;
    if (status.includes('error') || status.includes('fail')) return 100; 
    if (status.includes('cancel')) return 100;
    if (status.includes('pend') || status.includes('queue')) return 0;
    if (status.includes('trans')) return 60;
    if (status.includes('analy')) return 85;
    
    return 50;
  }
};

export default AudioProcessingService;